// extracted by mini-css-extract-plugin
export var icon = "index-module--icon--+VuoY";
export var title = "index-module--title--KzV2I";